var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import { getApiClient } from "../../services/AxiosClients";
const BASE_URL = "/aviso/department";
export default class DepartmentService {
    static search(search = {}, options = {}) {
        return FetchService.getPagedResponse(BASE_URL + "/search", {
            ids: search.ids,
            names: search.names,
            acronyms: search.acronyms,
            active: search.active,
            srcSystemIds: search.srcSystemIds,
            query: search.query,
            max: options.max,
            offset: options.offset,
            sort: options.sort,
            order: options.order,
        });
    }
    static findAllById(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            // fetch the specific departments from the API
            const apiClient = getApiClient();
            const response = yield apiClient.get(`/departments/search/findByIdIn?ids=${ids.join(",")}`);
            return response.data._embedded.departments;
        });
    }
}
